module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-sm-offset-2"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "submit": "#"
    }
  }, [(!_vm.isCreation) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.$dirty && this.$v.previousPassword.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Previous Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previousPassword),
      expression: "previousPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.previousPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previousPassword = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.$dirty && this.$v.password.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': this.$v.$dirty && this.$v.confirmPassword.$invalid
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-3"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default col-sm-offset-5",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger col-sm-offset-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("Create")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3689484b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Password.vue
// module id = 432
// module chunks = 1